// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__m76ta","dishesContainer":"styles_dishesContainer__KwkmJ","popup":"styles_popup__4onOG"};